import axiosinstance from './axiosinstance'
import { serviceinstance } from './instance'

export const loginUSER = async ({ LoginName, Password, Url = 'www.kit19.com', DeviceId = '10-60-4B-7A-92-E5' } = {}) => {
    const payload = {
        Status: '',
        Message: '',
        Details: {
            LoginName: LoginName || '',
            Password: Password || '',
            Url: Url || '',
            DeviceId: DeviceId || '',
        },
    }

    try {
        const response = await serviceinstance.post('Admin/GetDeviceToken', payload, {
            transformResponse: [data => data] // Keep raw to prevent JS precision loss
        })
        
        const rawText = response.data;
        let data;
        try {
            data = JSON.parse(rawText);
            
            // Extract the Token manually using Regex to preserve full integer precision
            // Standard JSON.parse rounds large numbers (> 9007199254740991)
            const tokenMatch = rawText.match(/"Token"\s*:\s*(-?\d+)/);
            if (tokenMatch && tokenMatch[1] && data && data.Details) {
                data.Details.Token = tokenMatch[1]; // Store as exact string
            }
        } catch (e) {
            console.error('Failed to parse login response safely', e);
            data = response.data; // fallback
        }
        
        return data
    } catch (error) {
        console.error('Error in login User', error)
        throw error
    }
}